import * as React from 'react';
import { UIComponentViewImpl } from '../../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../../../../toolkit/uicomponent';
import { ToneCardComponentProps, ToneCardComponentHandler, ToneCardComponentState } from './tonecardcomponent';
import { PlayerHandler } from '../../../../../../utils/player/playmanager';
import { BaseContext } from '../../../../../../utils/basecontext';
import { ImageLoaderCSSStyle } from '../../../../../toolkit/imageloader/imageloadercss';
import { ImageLoaderComponent } from '../../../../../toolkit/imageloader/imageloadercomponent';
import { PopUpWrapperComponent } from '../../../../popup/popupwrappercomponent';
import { GiftAFriendComponent } from '../../../../popup/giftafriend/giftafriendcomponent';
import { ShareToneComponent } from '../../../../popup/sharetone/sharetonecomponent';
import { TellAFriendComponent } from '../../../../popup/tellafriend/tellafriendcomponent';
import { ToneOptionsType } from '../../../../popup/tonedetailspopup/tonedetailspopupcomponent';
import { ToneCardImageLoaderCSSStyleImpl } from './tonecardimageloadercss';
import { ToneEvenCardImageLoaderCSSStyleImpl } from './toneevencardimageloader';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { PlayerWithProgressComponent } from 'src/com/sixdee/crbtportal/ui/toolkit/player/playerwithprogress/playerwithprogress';
import { DropDownListComponent } from 'src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownlistcomponent';
import { ToneOptionDropDownListCSSStyleImpl } from './toneoptions/toneoptiondropdownlistcss';
import { ToneOptionDropDownRowViewModelImpl } from './toneoptions/toneoptiondropdownlistviewmodel';
import { DropDownDto, DropDownDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/dropdown/dropdowndto';
import { DropdownRowViewModelHandler } from 'src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownrow/dropdownviewmodel';
import { ToneCardCSSStyle } from './tonecardcssstyle';
import { AlertComponent } from 'src/com/sixdee/crbtportal/ui/toolkit/alert/alertcomponent';
import { AlertType } from 'src/com/sixdee/crbtportal/ui/toolkit/alert/alerttype';
import { BuyToneComponent } from '../../../../popup/buytone/buytonecomponent';
import { SubscriptionPlanComponent } from '../../../../popup/subscription_plan/subscriptionplancomponent';
import { OTPVerificationComponent } from '../../../../popup/otpverification/otpverificationcomponent';
import { RoutingFeatures } from '../../../../navigation/routingfeature';
import { DeleteConfirmComponent } from '../../../../popup/deleteconfirmation/deleteconfirmationcomponent';
import { LoaderWrapperComponent } from '../../../../popup/loaderwrappercomponent';
import { LoaderComponent } from 'src/com/sixdee/crbtportal/ui/toolkit/loader/loadercomponent';
import { AudioPlayerWithProgress, AudioPlayerWithProgressHandler } from 'src/com/sixdee/crbtportal/ui/toolkit/player/playerwithprogress/playerwithprogressimpl';
// import { RoutingFeatures } from '../../../../navigation/routingfeature';
import './tone-card-style.css';
import { ToneMobileCardImageLoaderCSSStyleImpl } from './tonemobilecardimageloadercss';
import { ToneMobileEvenCardImageLoaderCSSStyleImpl } from './tonemobileevencardimageloader';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
import { UpgradePackComponent } from '../../../../popup/upgrade_pack/upgradepackcomponent';

export class ToneCardViewImpl extends UIComponentViewImpl<UIDataModel> implements AudioPlayerWithProgressHandler, PlayerHandler, DropdownRowViewModelHandler
{
    private playerComponent: PlayerWithProgressComponent | null;
    private initialStateOfTonePlaying: boolean;
    private imageLoaderCSSStyle: ImageLoaderCSSStyle;
    private evenImageLoaderCSSStyle: ImageLoaderCSSStyle;
    private imageMobileLoaderCSSStyle: ImageLoaderCSSStyle;
    private evenMobileImageLoaderCSSStyle: ImageLoaderCSSStyle;
    private loaderWrapperComponent:LoaderWrapperComponent;
    // private playerCSSStyle: PlayerComponentCSSStyle;
    private popUpComponent: PopUpWrapperComponent;
    private listViewModel: ToneOptionDropDownRowViewModelImpl;
    private audioPlayerWithProgress: AudioPlayerWithProgress;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);

        this.imageLoaderCSSStyle = new ToneCardImageLoaderCSSStyleImpl(context);
        this.evenImageLoaderCSSStyle = new ToneEvenCardImageLoaderCSSStyleImpl(context);
        // this.playerCSSStyle = new ToneCardPlayerCSSStyleImpl(context);
        this.imageMobileLoaderCSSStyle = new ToneMobileCardImageLoaderCSSStyleImpl(context);
        this.evenMobileImageLoaderCSSStyle = new ToneMobileEvenCardImageLoaderCSSStyleImpl(context);
        this.listViewModel = new ToneOptionDropDownRowViewModelImpl(true, context, this);
    }

    bindHandlers()
    {
        this.onSelected = this.onSelected.bind(this);
        this.onHovered = this.onHovered.bind(this);
        this.onHoveredExit = this.onHoveredExit.bind(this);
        this.onActionHovered = this.onActionHovered.bind(this);
        this.onActionHoveredExit = this.onActionHoveredExit.bind(this);
        this.onPlayClicked = this.onPlayClicked.bind(this);
        this.onStopClicked = this.onStopClicked.bind(this);
        this.onBuyToneClicked = this.onBuyToneClicked.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.getLikeCount = this.getLikeCount.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.showToneOptionsPopup = this.showToneOptionsPopup.bind(this);
        this.onTryAgainClick = this.onTryAgainClick.bind(this);
        this.onSettingsClicked = this.onSettingsClicked.bind(this);
        this.onDeleteConfirmed = this.onDeleteConfirmed.bind(this);
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onDeleteSuccess = this.onDeleteSuccess.bind(this);
        this.login = this.login.bind(this);
    }


    draw(props: ToneCardComponentProps, state: ToneCardComponentState, cssStyle: ToneCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        this.listViewModel.setListDatas(this.getListOfDropDown(props.context));
       
        return (
            <>
              <div id="tone-card-wrapper">
                                {
                                    this.getWebView(props, state, cssStyle)
                                }
                    </div>
                    
              {/* <div id="tone-card-col-wrapper">
                                {
                                    this.getMobileView(props, state, cssStyle)
                                }
                </div>
                <div id="tonecard-col2-wrapper">
                    {
                        this.getWebView(props, state, cssStyle)
                    }
                </div> */}

            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
        );
    }


    getWebView(props: ToneCardComponentProps, state: ToneCardComponentState, cssStyle: ToneCardCSSStyle)
    {
        return (
           <>
            <div id="tone-card-main-wrapper" key={props.position} style={props.cardStyle.getToneWrapperCSSStyle(props.marginTop)} onMouseEnter={this.onHovered} onMouseLeave={this.onHoveredExit}>
                {
                    <>
                       <div id="tone-extra-option-web">
                           {
                               <> 
                               {state.isHovered && this.getToneExtraOptionsPart(props.cardStyle, state, props)}
                               {state.isActionHovered &&  this.getToneOptionsPart(cssStyle, state)}
                                </>
                            }    
                       </div>
                       <div id="tone-extra-option-mobile">
                           {
                               <>
                               {state.isHovered && this.getMobileToneExtraOptionsPart(props.cardStyle, state, props)}
                               {state.isActionHovered &&  this.getMobileToneOptionsPart(cssStyle, state)}
                                </>
                            }    
                       </div>
                    </>
                }     
                
                {/* <img ref={(item: any) => {this.img = item;}} onError={this.onImgError} alt="" src={props.toneDto.getImgPath()} style={cssStyle.getImgCSSStyle()}/>    */}
                {
                  <>  
                    <div id="image-loader">
                        {
                                 this.getWebImageLoader(props)
                        }
                    </div>    
                    <div id="image-col-loader">
                        {
                                this.getMobileImageLoader(props)
                        }
                    </div>    
                  </> 
                }
                {state.toneRowOptionsPrivilage.isPlay() && <PlayerWithProgressComponent isAutoPlayRequired={props.isPlayInitial} position={props.position}  id={props.toneDto.getId()}  playIconName={"play.svg"} pauseIconName={"pause.svg"} playerCSSStyle={props.playerCSSStyle} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/>}
                <div id="tone-card-details" style={props.cardStyle.getDetailsDivCssStyle()}>
                   {props.toneDto.getArtistName() !== "" && 
                   <div id="tone-card-title" style={props.cardStyle.getTitleDivCSSStle()}>
                        {/* style={{height: "30px", overflow: "hidden",marginTop:'7px',marginBottom:'3px'}} */}
                     <div id="tone-card-tonename-div">
                        <label title={props.toneDto.getToneName()} id="tone-card-tonename-label" style={props.cardStyle.getToneNameCSSStyle()}>{props.toneDto.getToneName()}</label>
                     </div>
                     {/* style={{height: "20px", overflow: "hidden"}} */}
                     <div id="tone-card-artistname-div" >
                        <label title={props.toneDto.getArtistName()} id="tone-card-artistname-label" style={cssStyle.getArtistNameCSSStyle()}>{props.toneDto.getArtistName()}</label>
                     </div>
                  </div>
                   }
                   {props.toneDto.getArtistName() === "" && 
                   <div id="tone-card-title" style={props.cardStyle.getTitleDivCSSStle()}>
                       {/* style={{height: "30px", overflow: "hidden",marginTop:'30px',marginBottom:'3px'}} */}
                     <div id="tone-card-tonename-div" >
                        <label id="tone-card-tonename-label" style={props.cardStyle.getToneNameCSSStyle()}>{props.toneDto.getToneName()}</label>
                     </div>
                  </div>
                   }
                    <div id="tone-card-button" style={cssStyle.getButtonCSSStyle()} >
                        {
                            <>
                            <div id="button-div">
                                {/* {<>
                                     <div style={{width:'24px', height:'100%', marginLeft: !state.toneRowOptionsPrivilage.isBuy() && !state.toneRowOptionsPrivilage.isSettings() ? '40px' : "0px", marginRight:!state.toneRowOptionsPrivilage.isBuy() && !state.toneRowOptionsPrivilage.isSettings() ? '0px' : "20px"}}>
                                     {state.toneRowOptionsPrivilage.isGift() && <img title={props.context.getResources().getString(Strings.gift_a_friend)} onClick={(e)=>this.showToneOptionsPopup(props.context.getResources().getString(Strings.gift_a_friend))} width='100%' height='100%' src={this.getUIProps().context.getResources().getImage("gift_grey.svg")}/>}
                                     </div>
                                     {state.toneRowOptionsPrivilage.isSettings() && <img  onClick={(e)=>this.onSettingsClicked(props.toneDto)} src={this.getUIProps().context.getResources().getImage("noun_setting.svg")} width='24px' height='100%'/>}
                                     {state.toneRowOptionsPrivilage.isBuy() && <img title={props.context.getResources().getString(Strings.buytone)} onClick={this.onBuyToneClicked} src={this.getUIProps().context.getResources().getImage("grey_buy.svg")} width='24px' height='100%'/>}
                               </>
                                } */}

                                    {<>
                                    {state.toneRowOptionsPrivilage.isGift() &&<div onClick={(e)=>this.showToneOptionsPopup(props.context.getResources().getString(Strings.gift_a_friend))} id="gift-tone-card-option-div">
                                             <img   width='24px' height='24px' src={this.getUIProps().context.getResources().getImage("gift_grey.svg")}/>
                                            <label id={this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "gift-tone-card-option-label" : "gift-tone-card-option-label-burmese"}>{this.getContext().getResources().getString(Strings.gift)}</label>
                                      </div>}  
                                      {state.toneRowOptionsPrivilage.isBuy() &&  <div onClick={this.onBuyToneClicked} id="buy-tone-card-option-div">
                                       <img   src={this.getUIProps().context.getResources().getImage("grey_buy.svg")} width='24px' height='24px'/>                                   
                                              <label id={this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"buy-tone-card-option-label":"buy-tone-card-option-label-burmese"}>{this.getContext().getResources().getString(Strings.buy)}</label>
                                      </div>}  
                                      
                                     {state.toneRowOptionsPrivilage.isSettings() && <div  onClick={(e)=>this.onSettingsClicked(props.toneDto)} id="buy-tone-card-option-div">
                                     <img   src={this.getUIProps().context.getResources().getImage("noun_setting.svg")} width='24px' height='100%'/>
                                     <label id={this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"buy-tone-card-option-label":"buy-tone-card-option-label-burmese"}>{this.getContext().getResources().getString(Strings.settings)}</label>
                                     </div>}
                                     </>}
                             </div>
                             <div id="button-col-div">
                                 {/* {
                                     <>
                                        <div style={{width:'20px', height:'20px',marginTop:'0px', marginLeft: !state.toneRowOptionsPrivilage.isBuy() && !state.toneRowOptionsPrivilage.isSettings() ? '20px' : "0px", marginRight:!state.toneRowOptionsPrivilage.isBuy() && !state.toneRowOptionsPrivilage.isSettings() ? '0px' : "7px"}}>
                                            {state.toneRowOptionsPrivilage.isGift() && <img title={props.context.getResources().getString(Strings.gift_a_friend)} onClick={(e)=>this.showToneOptionsPopup(props.context.getResources().getString(Strings.gift_a_friend))} width='20px' height='20px' src={this.getUIProps().context.getResources().getImage("gift_grey.svg")}/>}
                                        </div>
                                        {state.toneRowOptionsPrivilage.isSettings() && <img style={{marginTop:"3px"}} onClick={(e)=>this.onSettingsClicked(props.toneDto)} src={this.getUIProps().context.getResources().getImage("noun_setting.svg")} width='20px' height='20px'/>}
                                        {state.toneRowOptionsPrivilage.isBuy() && <img style={{marginTop:"3px"}} title={props.context.getResources().getString(Strings.buytone)} onClick={this.onBuyToneClicked} src={this.getUIProps().context.getResources().getImage("grey_buy.svg")} width='20px' height='20px'/>}
                                     </>
                                 } */}
                                  {state.toneRowOptionsPrivilage.isGift() &&<div onClick={(e)=>this.showToneOptionsPopup(props.context.getResources().getString(Strings.gift_a_friend))} id="gift-tone-card-option-div">
                                             <img   width='12px' height='12px' src={this.getUIProps().context.getResources().getImage("gift_grey.svg")}/>
                                            <label id={this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"gift-tone-card-option-label":"gift-tone-card-option-label-burmese"}>{this.getContext().getResources().getString(Strings.gift)}</label>
                                      </div>}  
                                      {state.toneRowOptionsPrivilage.isBuy() &&  <div onClick={this.onBuyToneClicked} id="buy-tone-card-option-div">
                                       <img  src={this.getUIProps().context.getResources().getImage("grey_buy.svg")} width='12px' height='12px'/>                                   
                                              <label id={this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"buy-tone-card-option-label":"buy-tone-card-option-label-burmese"}>{this.getContext().getResources().getString(Strings.buy)}</label>
                                      </div>}  
                                      
                                     {state.toneRowOptionsPrivilage.isSettings() && <div onClick={(e)=>this.onSettingsClicked(props.toneDto)} id="buy-tone-card-option-div">
                                     <img   src={this.getUIProps().context.getResources().getImage("noun_setting.svg")} width='12px' height='12px'/>
                                     <label id={this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"buy-tone-card-option-label":"buy-tone-card-option-label-burmese"}>{this.getContext().getResources().getString(Strings.settings)}</label>
                                     </div>}

                              </div> 
                          </>         
                        }
                    </div>
                 </div>

            </div>
            </>
        );
    }

    getWebImageLoader(props: ToneCardComponentProps):JSX.Element
    {
        return(
            <>
            {props.position % 2 === 0 ?<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.imageLoaderCSSStyle} context={props.context}/> :<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.evenImageLoaderCSSStyle} context={props.context}/>}
            </>
        );
    }

    getMobileImageLoader(props: ToneCardComponentProps):JSX.Element
    {
        return(
            <>
             {props.position % 2 === 0 ?<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.imageMobileLoaderCSSStyle} context={props.context}/> :<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.evenMobileImageLoaderCSSStyle} context={props.context}/>}
            </>
        );
    }
   
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    getToneOptionsPart(cssStyle: ToneCardCSSStyle, state: ToneCardComponentState)
    {
        return (
            <div id={(this.getUIProps() as ToneCardComponentProps).position % 2 !== 0 ? "tone-card-onhover-even" : "tone-card-onhover-odd"} style={cssStyle.getOnHoverCSSStyle()}>
            <div style={{width:'100%', height:'50px',display:'flex'}}>
                    <div style={cssStyle.getHeartDivCSSStyle()}>
                    {state.toneRowOptionsPrivilage.isLike() && 
                    <>
                     <img style={{cursor:"auto"}} src={this.getUIProps().context.getResources().getImage("heart.svg")}/>
                     <label style={{width:'100%',textAlign:'left',cursor:"auto",height:'10px',marginTop:'5px',color:'#FFFFFF',fontSize:'12px'}}>
                     {this.getLikeCount((this.getUIProps() as ToneCardComponentProps).toneDto) + " " + this.getUIProps().context.getResources().getString(Strings.likes)}
                     </label>
                     </>
                     }
                 </div>
                <div onMouseLeave={this.onActionHoveredExit} style={cssStyle.getDropDownSSStyle()}>
                    <DropDownListComponent cssStyle={new ToneOptionDropDownListCSSStyleImpl(this.getContext())} listViewModel={this.listViewModel} context={this.getUIProps().context}/>
                </div>
              </div>
              </div>);
    }

    getMobileToneOptionsPart(cssStyle: ToneCardCSSStyle, state: ToneCardComponentState)
    {
        return (
            <div id={(this.getUIProps() as ToneCardComponentProps).position % 2 !== 0 ? "tone-card-onhover-even" : "tone-card-onhover-odd"} style={cssStyle.getOnHoverCSSStyle()}>
            <div style={{width:'100%', height:'30px',display:'flex'}}>
                    <div style={cssStyle.getMobileHeartDivCSSStyle()}>
                    {state.toneRowOptionsPrivilage.isLike() && 
                    <>
                     <img style={{cursor:'auto'}} src={this.getUIProps().context.getResources().getImage("heart.svg")}/>
                     <div style={{width:'100%', cursor:'auto',textAlign:'left',height:'10px',marginTop:'0px',color:'#FFFFFF',fontSize:'9px'}}>
                     {this.getLikeCount((this.getUIProps() as ToneCardComponentProps).toneDto) + " " + this.getUIProps().context.getResources().getString(Strings.likes)}
                     </div>
                     </>
                     }
                 </div>
                <div onMouseLeave={this.onActionHoveredExit} style={cssStyle.getMobileDropDownSSStyle()}>
                    <DropDownListComponent cssStyle={new ToneOptionDropDownListCSSStyleImpl(this.getContext())} listViewModel={this.listViewModel} context={this.getUIProps().context}/>
                </div>
              </div>
            </div>);
    }     

    getToneExtraOptionsPart(cssStyle: ToneCardCSSStyle,state: ToneCardComponentState, props:ToneCardComponentProps)
    {
        return (
            <div id={(this.getUIProps() as ToneCardComponentProps).position % 2 !== 0 ? "tone-card-onhover-even" : "tone-card-onhover-odd"} style={cssStyle.getOnHoverCSSStyle()} onClick={this.onActionHoveredExit}>
               <div style={{width:'100%', height:'50px',display:'flex'}}>
                    <div style={cssStyle.getHeartDivCSSStyle()}>
                    {state.toneRowOptionsPrivilage.isLike() && 
                        <>
                        <img style={{cursor:'auto'}} src={this.getUIProps().context.getResources().getImage("heart.svg")}/>
                        <label style={{width:'100%',textAlign:'left',cursor:'auto',height:'10px',marginTop:'5px',color:'#FFFFFF',fontSize:'8px'}}>
                        {this.getLikeCount(props.toneDto) + " " + props.context.getResources().getString(Strings.likes)}
                        </label>
                        </>
                    }
                    </div>
                   
                          {state.toneRowOptionsPrivilage.isLike() && state.toneRowOptionsPrivilage.isTellAFriend() &&  <div style={cssStyle.getAnnounceDivCSSStyle()}>
                            <img onClick={(e)=>this.showToneOptionsPopup(props.context.getResources().getString(Strings.tellafriend))} src={this.getUIProps().context.getResources().getImage("tellafriend.svg")}/>
                                <label style={{width:'100%',textAlign:'center',height:'10px',marginTop:'5px',color:'#FFFFFF',fontSize:'12px'}}>
                                    {this.getContext().getResources().getString(Strings.tellafriend)}
                                </label>
                            </div>}

                            {!state.toneRowOptionsPrivilage.isLike() && state.toneRowOptionsPrivilage.isTellAFriend() && state.toneRowOptionsPrivilage.isAction() && <div style={cssStyle.getExtraActionDivCSSStyle("80%")} onClick={this.onActionHovered}>
                            <img src={this.getUIProps().context.getResources().getImage("action.svg")}/>
                                <label style={{width:'90%',textAlign:'right',height:'10px',marginTop:'5px',color:'#FFFFFF',fontSize:'12px'}}>
                                    {this.getContext().getResources().getString(Strings.more)}
                                </label>
                            </div>}

                            {state.toneRowOptionsPrivilage.isLike() && state.toneRowOptionsPrivilage.isAction() && <div style={cssStyle.getExtraActionDivCSSStyle(state.toneRowOptionsPrivilage.isTellAFriend() ? "30%" : "65%")} onClick={this.onActionHovered}>
                            <img src={this.getUIProps().context.getResources().getImage("action.svg")}/>
                                <label style={{width:'90%',textAlign:'right',height:'10px',marginTop:'5px',color:'#FFFFFF',fontSize:'12px'}}>
                                    {this.getContext().getResources().getString(Strings.more)}
                                </label>
                            </div>}
               </div> 
            </div>);
    }

    getMobileToneExtraOptionsPart(cssStyle: ToneCardCSSStyle,state: ToneCardComponentState, props:ToneCardComponentProps)
    {
        return (
            <div id={(this.getUIProps() as ToneCardComponentProps).position % 2 !== 0 ? "tone-card-onhover-even" : "tone-card-onhover-odd"} style={cssStyle.getOnHoverCSSStyle()} onClick={this.onActionHoveredExit}>
               <div style={{width:'100%', height:'30px',display:'flex'}}>
                    <div style={cssStyle.getMobileHeartDivCSSStyle()}>
                    {state.toneRowOptionsPrivilage.isLike() && 
                        <>
                        <img style={{cursor:"auto"}} height="15px" width="90%" src={this.getUIProps().context.getResources().getImage("heart.svg")}/>
                        <div style={{width:'100%',cursor:"auto",textAlign:'left',height:'10px',marginTop:'0px',color:'#FFFFFF',fontSize:'9px'}}>
                        {this.getLikeCount(props.toneDto) + " " + props.context.getResources().getString(Strings.likes)}
                        </div>
                        </>
                    }
                    </div>
                   
                          {/* {state.toneRowOptionsPrivilage.isTellAFriend() &&  <div style={cssStyle.getMobileAnnounceDivCSSStyle()}>
                            <img height="15px" width="90%" onClick={(e)=>this.showToneOptionsPopup(props.context.getResources().getString(Strings.tellafriend))} src={this.getUIProps().context.getResources().getImage("tellafriend.svg")}/>
                                <label style={{width:'100%',textAlign:'center',height:'10px',marginTop:'5px',color:'#FFFFFF',fontSize:'9px'}}>
                                    {this.getContext().getResources().getString(Strings.tellafriend)}
                                </label>
                            </div>} */}

                            {state.toneRowOptionsPrivilage.isAction() && <div style={cssStyle.getMobileExtraActionDivCSSStyle(state.toneRowOptionsPrivilage.isTellAFriend() ? "30%" : "65%")} onClick={this.onActionHovered}>
                            <img style={{marginLeft:"auto"}} height="15px" width="70%" src={this.getUIProps().context.getResources().getImage("action.svg")}/>
                                <div style={{width:'100%',textAlign:'center',height:'10px',marginLeft:'5px',color:'#FFFFFF',fontSize:'9px'}}>
                                    {this.getContext().getResources().getString(Strings.more)}
                                </div>
                            </div>}
               </div> 
              
            </div>);
    }  


     getLikeCount(toneDto: ToneDto): string
    {
        return toneDto.getLikeCount() === undefined ? "0" : toneDto.getLikeCount();
        // let formattedCount = this.getContext().getResources().getString(Strings.zero);

        // if(toneDto.getLikeCount() !== undefined)
        // {      
        //     if(+toneDto.getLikeCount() < +this.getContext().getResources().getString(Strings.thousand))
        //     {
        //         formattedCount = toneDto.getLikeCount();
        //     }
        //     else if(+toneDto.getLikeCount() >= +this.getContext().getResources().getString(Strings.thousand) && +toneDto.getLikeCount() < +this.getContext().getResources().getString(Strings.thousand))
        //     {
        //         formattedCount = (+toneDto.getLikeCount()/+this.getContext().getResources().getString(Strings.thousand)) + this.getContext().getResources().getString(Strings.K);
        //     }
        //     else if(+toneDto.getLikeCount() >= 100000 && +toneDto.getLikeCount() < 100000)
        //     {
        //         formattedCount = (+toneDto.getLikeCount()/100000) + this.getContext().getResources().getString(Strings.K);
        //     }
        //     else
        //     {
        //         formattedCount = (+toneDto.getLikeCount()/+this.getContext().getResources().getString(Strings.million)) + this.getContext().getResources().getString(Strings.M);
        //     }

        //     return formattedCount;//.replace("."+ this.getContext().getResources().getString(Strings.zero), "");
        // }
        // else
        // {
        //     return formattedCount;
        // }
    }
    onPlayComplete(): void 
    {
        this.initialStateOfTonePlaying = false;
        this.playerComponent !== null && this.playerComponent.onPlayComplete();
    }
   
    onPlayStop(): void 
    {
        this.initialStateOfTonePlaying = false;
        this.playerComponent !== null && this.playerComponent.onPlayStop();
    }

    protected onBuyToneClicked(): void 
    {
        this.playerComponent !== null && this.playerComponent.onStopClicked();
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
        // <OTPVerificationComponent onClick={()=>''}  closePopup={this.closePopup} context={this.getContext()}/>);
            <BuyToneComponent showPopupOption={this.showToneOptionsPopup} getPopupWrapper={this.getPopUpWrapper} showPopup={this.showPopup}   toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} context={this.getUIProps().context}/>);
    }

   
    protected closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    onDeleteClicked()
    {
        this.showToneOptionsPopup(this.getUIProps().context.getResources().getString(Strings.delete));
    }
     showToneOptionsPopup(id:string):void
     {
        this.playerComponent !== null && this.playerComponent.onStopClicked();
        if(id === this.getUIProps().context.getResources().getString(Strings.gift_a_friend))
        {
            if(!this.getUIProps().context.getUserContext().getIsLoggedIn())
            {
                // this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.LOGIN, false);
                this.popUpComponent !== null &&  this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.login)} alertMessage={this.getContext().getResources().getString(Strings.authenticatemsg)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closePopup} onClick={this.login} context={this.getUIProps().context}/>);
            }
            else 
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                    <GiftAFriendComponent showPopup={this.showPopup} toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} context={this.getUIProps().context}/>);
            }
        }
        else if(id === this.getUIProps().context.getResources().getString(Strings.wishlist))
        {
            if(!this.getUIProps().context.getUserContext().getIsLoggedIn())
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.login)} alertMessage={this.getContext().getResources().getString(Strings.authenticatemsg)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closePopup} onClick={this.login} context={this.getUIProps().context}/>);
            }
            else 
            {
            (this.getUIComponentHandler() as ToneCardComponentHandler).addToWishlist();
            }
        }
        else if(id === this.getUIProps().context.getResources().getString(Strings.shareatone))
        {
            if(!this.getUIProps().context.getUserContext().getIsLoggedIn())
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.login)} alertMessage={this.getContext().getResources().getString(Strings.authenticatemsg)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closePopup} onClick={this.login} context={this.getUIProps().context}/>);
            }
            else 
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <ShareToneComponent  toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} context={this.getUIProps().context}/>);
            }
        }
        else if(id === this.getUIProps().context.getResources().getString(Strings.delete))
        {
            if(!this.getUIProps().context.getUserContext().getIsLoggedIn())
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.login)} alertMessage={this.getContext().getResources().getString(Strings.authenticatemsg)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closePopup} onClick={this.login} context={this.getUIProps().context}/>);
            }
            else 
            {
                this.showDeleteConfirmationPopUp(id);
            }
        }
        else if(id === this.getUIProps().context.getResources().getString(Strings.tellafriend))
        {
            if(!this.getUIProps().context.getUserContext().getIsLoggedIn())
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.login)} alertMessage={this.getContext().getResources().getString(Strings.authenticatemsg)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closePopup} onClick={this.login} context={this.getUIProps().context}/>);
            }
            else 
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <TellAFriendComponent showPopup={this.showPopup} toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} context={this.getUIProps().context}/>);
            }
        }
       else  if(id === this.getUIProps().context.getResources().getString(Strings.buy_nametune) + "_" + 
       this.getUIProps().context.getResources().getString(Strings.subscription))
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <SubscriptionPlanComponent id={this.getUIProps().context.getResources().getString(Strings.buy_nametune)} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
   
        }
        else  if(id === this.getUIProps().context.getResources().getString(Strings.buy_now) + "_" + 
        this.getUIProps().context.getResources().getString(Strings.subscription))
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <SubscriptionPlanComponent id={this.getUIProps().context.getResources().getString(Strings.buy_now)} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
   
        }
        else  if(id === this.getUIProps().context.getResources().getString(Strings.buy_now) + "_" + 
        this.getUIProps().context.getResources().getString(Strings.upgradePack))
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <UpgradePackComponent id={this.getUIProps().context.getResources().getString(Strings.buy_now)} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
   
        }
        else  if(id === this.getUIProps().context.getResources().getString(Strings.buy_now) + "_" +
        this.getUIProps().context.getResources().getString(Strings.otp_verification))
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <OTPVerificationComponent toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} id={this.getUIProps().context.getResources().getString(Strings.buy_now)} showOptionsPopup={this.showToneOptionsPopup} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
   
        }
        else  if(id === this.getUIProps().context.getResources().getString(Strings.buy_now) + "_" +
        this.getUIProps().context.getResources().getString(Strings.upgradePack) + "_" + 
        this.getUIProps().context.getResources().getString(Strings.otp_verification))
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <OTPVerificationComponent toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} id={this.getUIProps().context.getResources().getString(Strings.upgradePack)} showOptionsPopup={this.showToneOptionsPopup} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
   
        }
      
        else  if(id === this.getUIProps().context.getResources().getString(Strings.buy_nametune) + "_" +
        this.getUIProps().context.getResources().getString(Strings.otp_verification))
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <OTPVerificationComponent toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto}  id={this.getUIProps().context.getResources().getString(Strings.buy_nametune)} showOptionsPopup={this.showToneOptionsPopup} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
   
        }
        else if(id === this.getUIProps().context.getResources().getString(Strings.buytone))
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <BuyToneComponent showPopupOption={this.showToneOptionsPopup} getPopupWrapper={this.getPopUpWrapper} showPopup={this.showPopup}   toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} context={this.getUIProps().context}/>);
        }
     }

     showDeleteConfirmationPopUp(id: string)
     {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, 
            <DeleteConfirmComponent msg={this.getContext().getResources().getString(Strings.The_tune_will_be_deleted_and_all_related_settings_will_no_longer_be_available)} id={id}  headerTitle={this.getContext().getResources().getString(Strings.confirm)} closePopup={this.closePopup} context={this.getContext()} onConfirmClick={this.onDeleteConfirmed} onCancelClick={this.closePopup} />);
     }
     login()
     {
         this.closePopup();
        this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.LOGIN, false);
     }
     onDeleteConfirmed():void
     {
        (this.getUIComponentHandler() as ToneCardComponentHandler).onDeleteClicked();

     }

     
    showPopup(id:string,msg:string,type:AlertType):void
    {
        this.closePopup();
         if(type === AlertType.WARN)
         {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.tryagain)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={(e)=>this.onTryAgainClick(id)} context={this.getUIProps().context}/>);
         }
         else if(id === this.getContext().getResources().getString(Strings.delete) && type === AlertType.SUCCESS)
         {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.onDeleteSuccess} onClick={this.onDeleteSuccess} context={this.getUIProps().context}/>);
         }
        
         else 
         {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
         }
    }
    onDeleteSuccess():void
    {
        this.closePopup();
        (this.getUIProps() as ToneCardComponentProps).onDeleteClicked((this.getUIProps() as ToneCardComponentProps).toneDto);
        // this.props.onDeleteClicked(this.props.toneDto);

    }


    onTryAgainClick(id:string):void
    {
        this.closePopup();
        this.showToneOptionsPopup(id);
    }
    protected getPopUpWrapper():PopUpWrapperComponent
    {
        return this.popUpComponent;
    }
   
    protected onHovered(): void 
    {
        // this.playerComponent !== null && this.playerComponent.onStopClicked();
        if(!(this.getUIState() as ToneCardComponentState).isActionHovered)
        {
            (this.getUIComponentHandler() as ToneCardComponentHandler).onHovered();
        }
    }
 
    protected onHoveredExit(): void 
    {
        (this.getUIComponentHandler() as ToneCardComponentHandler).onHoveredExit();
    }

    protected onActionHovered(): void 
    {
        this.playerComponent !== null && this.playerComponent.onStopClicked();
        (this.getUIComponentHandler() as ToneCardComponentHandler).onActionHovered();
    }
 
    protected onActionHoveredExit(): void 
    {
        (this.getUIComponentHandler() as ToneCardComponentHandler).onActionHoveredExit();
    }

    onSettingsClicked(toneDto:ToneDto)
    {
       
            this.playerComponent !== null && this.playerComponent.onStopClicked();
            (this.getUIComponentHandler() as ToneCardComponentHandler).onSettingsClicked();
       
        
    }
    
    setPlayerWithProgress(audioPlayerWithProgress: AudioPlayerWithProgress)
    {
        this.audioPlayerWithProgress = audioPlayerWithProgress;
        if(this.playerComponent !== null)
        {
            this.playerComponent.updateProgress(0);
            this.playerComponent.onStopClicked();
            this.getContext().getPlayerManager().release();
            this.audioPlayerWithProgress.startProgress(undefined);
        }
        // this.playerComponent !== null && this.playerComponent.setPlayerWithProgress(this);
    }
  
    onPlayStart()
    {
        if(this.playerComponent !== null)
        {
    //         this.audioPlayerWithProgress.startProgress(this);
            this.playerComponent.playStart();
            // this.onPlayClicked();
        }
    }
    onPlayClicked(): void
    {
        this.initialStateOfTonePlaying = true;

        this.getContext().getPlayerManager()
                    .startPlay((this.getUIProps() as ToneCardComponentProps).toneDto.getToneUrl(), this);
        this.audioPlayerWithProgress.startProgress(this);
    }

    updateProgress(percentage: number): void 
    {
        this.playerComponent !== null && this.playerComponent.updateProgress(percentage);
    }

    protected onStopClicked(): void
    {
        this.initialStateOfTonePlaying = false;

        this.getContext().getPlayerManager().stopPlay();
    }

    protected onSelected()
    {
        (this.getUIState() as ToneCardComponentState).toneRowOptionsPrivilage.isToneSelect() &&
        (this.getUIComponentHandler() as ToneCardComponentHandler).onSelected();
    }

    onRowSelected(dropDownDto: DropDownDto): void 
    {
        this.showToneOptionsPopup(dropDownDto.getId());
    }

    getPlayerComponent()
    {
        return this.playerComponent;
    }
    private getListOfDropDown(context: BaseContext)
    {  
        let dropDownList = [];

        let state = (this.getUIState() as ToneCardComponentState);

        if(state.toneRowOptionsPrivilage.isTellAFriend())
        {
            let dropDown1 = new DropDownDtoImpl();
           dropDown1.setId(context.getResources().getString(Strings.tellafriend));
           dropDown1.setIconName(this.getContext().getResources().getString(Strings.tell_a_friend));
           dropDown1.setTitle(context.getResources().getString(Strings.tellafriend));

           dropDownList.push(dropDown1);
        }

        if(state.toneRowOptionsPrivilage.isAddWishlist())
       {
        let dropDown2 = new DropDownDtoImpl();
        dropDown2.setId(context.getResources().getString(Strings.wishlist));
        dropDown2.setIconName(this.getContext().getResources().getString(Strings.wish_list));
        dropDown2.setTitle(context.getResources().getString(Strings.wishlist));

        dropDownList.push(dropDown2);
        }
    
   
    //    if(state.toneRowOptionsPrivilage.isShare())
    //    {
    //         let dropDown3 = new DropDownDtoImpl();
    //         dropDown3.setId(context.getResources().getString(Strings.shareatone));
    //         dropDown3.setIconName(this.getContext().getResources().getString(Strings._share));
    //         dropDown3.setTitle(context.getResources().getString(Strings.share));

    //         dropDownList.push(dropDown3);
    //    }

       
       if(state.toneRowOptionsPrivilage.isDelete())
       {
            let dropDown3 = new DropDownDtoImpl();
            dropDown3.setId(context.getResources().getString(Strings.delete));
            dropDown3.setIconName(this.getContext().getResources().getString(Strings.delete_trash));
            dropDown3.setTitle(context.getResources().getString(Strings.delete));

            dropDownList.push(dropDown3);
       }

        return dropDownList;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/tonecardview.tsx